import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonProgressBar, IonTitle, IonToolbar } from '@ionic/react';
import { close } from 'ionicons/icons';
import React, { memo } from 'react';
import PushNotificationSettingsForm from '../components/PushNotificationSettingsForm';
import { LoadFailureStateContainer, LoadingStateContainer } from '../components/StateContainer';
import { useTranslation } from '../hooks/useTranslation';
import { usePushNotificationConfigQuery } from '../query/pushNotificationConfigQuery';

interface PushNotificationSettingsModalProps {
    dismiss: (data?: string | null, role?: string) => void;
}

const PushNotificationSettingsModal: React.FC<PushNotificationSettingsModalProps> = ({ dismiss }) => {
    const { t } = useTranslation('modals');
    const pushNotificationConfigQuery = usePushNotificationConfigQuery();

    return (
        <IonPage>
            <IonHeader translucent>
                <IonToolbar>
                    <IonTitle>{t('push_notification_settings.title')}</IonTitle>
                    <IonButtons slot="primary">
                        <IonButton
                            aria-label={t('push_notification_settings.close')}
                            onClick={() => dismiss(null, 'cancel')}
                        >
                            <IonIcon slot="icon-only" icon={close} />
                        </IonButton>
                    </IonButtons>
                    {(pushNotificationConfigQuery.isLoading || pushNotificationConfigQuery.isFetching) && (
                        <IonProgressBar type="indeterminate" />
                    )}
                </IonToolbar>
            </IonHeader>
            <IonContent color="light" fullscreen>
                {pushNotificationConfigQuery.isLoading && <LoadingStateContainer />}

                {pushNotificationConfigQuery.isError && (
                    <LoadFailureStateContainer
                        subtitle={t('push_notification_settings.failed_to_load')}
                        error={pushNotificationConfigQuery.error as Error}
                        onRetry={() => pushNotificationConfigQuery.refetch()}
                    />
                )}

                {pushNotificationConfigQuery.data && (
                    <PushNotificationSettingsForm config={pushNotificationConfigQuery.data} />
                )}
            </IonContent>
        </IonPage>
    );
};

export default memo(PushNotificationSettingsModal);
